import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Languages } from '../constants';
import { useApplicationParams } from './application-params.context';
import { useLanguage } from './application-language.context';

const UserProfileContext = createContext(null);

export const useUserProfile = () => {
  const context = useContext(UserProfileContext);

  if (context === undefined) {
    throw new Error(`Error use user profile hook outside context provider`);
  }

  return context;
};

export const UserProfileProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(null);

  const { appVersion, platform, deviceId, userToken } = useApplicationParams();
  const { language } = useLanguage();

  useEffect(() => {
    if (!userToken) {
      return;
    }

    const cancelToken = axios.CancelToken.source();

    const getUserDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/subscribers/me/profile`,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-version': appVersion || '4.11.1',
              'x-api-key': process.env.REACT_APP_API_KEY,
              'x-api-os': platform || 'android',
              'x-user-lang': language || Languages.English,
              'x-api-device-id': deviceId || 'CBC64810-FF0C-4008-9558-A999C18085E7',
              authorization: userToken || '',
            },
            cancelToken: cancelToken.token,
          },
        );

        if (response.data.status === 'success') {
          setUserDetails(response.data.data);

          window.analyticsUser = response.data.data;
          window.setAnalyticsUser(response.data.data);
        }
      } catch (error) {
        console.error(`Error get user details: ${error?.message}`);
      }
    };

    getUserDetails();

    return () => {
      cancelToken.cancel();
    };
  }, [userToken]);

  return <UserProfileContext.Provider value={userDetails}>{children}</UserProfileContext.Provider>;
};
